export default function reducer(
    state = {
        status: "",
        error: null,
        history: {
            byid: {},
            list: [],
            count: 0,
            total: 0,
            currentPage: 1,
            itemPerPage: 10,
            pageCount: 1
        },
        log: null,
        typeahead: {
            staffId: [],
            device: [],
            name: []
        },
        details: null
    },
    action
) {
    //console.log("Reducers > panics > action:", action)
    switch (action.type) {
        case "CLEAR_STORE":
            state = defaultState()
            break;
        case "PANICS_FILTERED_HISTORY_FULFILLED":
        case "PANICS_HISTORY_FULFILLED":
            state = _history(state, action.payload.data)
            break;
        case "PANICS_HISTORY_CURRPAGE":
            state = {
                ...state,
                history: {
                    ...state.history,
                    currentPage: action.payload.index
                }
            }
            break;
        case "PANICS_HISTORY_ITEMPERPAGE":
            state = {
                ...state,
                history: {
                    ...state.history,
                    itemPerPage: action.payload.count,
                    pageCount: Math.ceil(state.history.total / action.payload.count),
                    currentPage: 1
                }
            }
            break;
        case "PANICS_TYPEAHEAD_FULFILLED":
            state = {
                ...state,
                typeahead: {
                    ...state.typeahead,
                    ...action.payload.data
                }
            }
            break;
        case "PANICS_HISTORY_CLEAR":
            state = {
                ...state,
                history: {
                    ...state.history,
                    byid: {},
                    list: [],
                    count: 0,
                    total: 0,
                    currentPage: 1,
                    pageCount: 1
                }
            }
            break;
        case "PANICS_LOG_FULFILLED":
            state = {
                ...state,
                log: action.payload.data
            }
            break;
        case "PANICS_LOG_CLEAR":
            state = {
                ...state,
                log: null
            }
            break;
        default:
            break;
    }
    return state;
}

function defaultState() {
    return {
        status: "",
        error: null,
        history: {
            byid: {},
            list: [],
            count: 0,
            total: 0,
            currentPage: 1,
            itemPerPage: 10,
            pageCount: 1
        },
        log: null,
        typeahead: {
            staffId: [],
            device: [],
            name: []
        },
        details: null
    }
}

function _history(state, data) {
    //console.log("_history > data :\n", data);

    if (state.history.list.length < 1 || state.history.total !== data.total) {
        state = {
            ...state,
            history: {
                ...state.history,
                list: new Array(data.total).fill(-1),
            }
        }
    }
    let __list = [...state.history.list]
    __list.splice(data.skip, data.list.length, ...data.list)

    state = {
        ...state,
        history: {
            ...state.history,
            byid: { ...state.history.byid, ...data.data },
            list: __list,
            total: data.total,
            pageCount: Math.ceil(data.total / state.history.itemPerPage)
        }
    }
    state = {
        ...state,
        history: {
            ...state.history,
            count: state.history.list.length
        }
    }

    return state
}


// WEBPACK FOOTER //
// ./src/redux/reducers/_panics.js